import { render, staticRenderFns } from "./UpdateTagModal.vue?vue&type=template&id=aa1972d6&scoped=true"
import script from "./UpdateTagModal.vue?vue&type=script&lang=js"
export * from "./UpdateTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1972d6",
  null
  
)

export default component.exports